import { useEffect, useReducer, useState } from 'react';
import { translate } from './api';
import { LanguageCode } from './languages';

const VALUES = [
  'Select a language',
  'Choose a language',
  'Retry',
  'Hide',
  'Show',
  'Translate',
  'Play',
  'Ask',
  'Remove',
  'Restore',
  'Start',
  'Continue',
  'Review reminders',
  'Enable reminders',
  'Disable reminders',
  'To enable reminders, click the share button',
  'then add to Home Screen.',
  'NOTE: Home screen apps and Safari do not share data, log in to sync across devices.',
  'Verification code',
  'Verification code sent',
  'Log in with phone',
  'By clicking "Log in with phone", you agree to receive a one-time SMS verification code from DirtyLingo.',
  'Resend code',
  'Resend code in {time}',
  'Verify',
  'Failed to send code',
  'Failed to verify code',
  'Use +15555551234 format',
  'Sync across devices',
  'Manage device sync',
  'Disconnect sync',
  'Sync now',
  'Syncing...',
  'Last synced',
  'Sync error',
  'Never',
  'Manage data',
  'Details',
  'Expression',
  'Audio',
  'Pronunciation',
  'Translation',
  'Description',
  'Refresh',
  'Slow',
  'Copy conversation',
  'Paste conversation',
  'State copied',
  'State imported',
  'Failed to import state',
  'Clear history',
  'Clear conversation history?',
  'Mic on',
  'Mic off',
  'Auto listen',
  'Record button',
  'Recording',
  'Record',
  'Input mode',
  'Exit lesson',
  'Home',
  'Failure reason',
  'Explanation',
] as const;

export type LocalizedValues = typeof VALUES[number];

const translations: { [key: string]: string | null } = {};

export let currentCode: LanguageCode = 'en';

export const useLocalize = (code: LanguageCode): [LanguageCode, (code: LanguageCode) => void] => {
  const [currentCode, setCurrentCode] = useState(code);
  const [, update] = useReducer((a) => a + 1, 0);

  const load = async (): Promise<void> => {
    for (const value of VALUES) {
      if (currentCode === 'en') {
        translations[value] = null;
      } else {
        const translation = await translate(value, currentCode);
        translations[value] = translation;
      }
    }
    update();
  };

  useEffect(() => {
    load();
  }, [currentCode]);

  return [currentCode, setCurrentCode];
};

export const localize = (value: LocalizedValues): string => {
  return translations[value] ?? value;
};
